var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.6733V1H27.6667L65 38.3333L38.3333 65L1 27.6733Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6199 15.5135C13.7701 15.5135 15.5132 13.7703 15.5132 11.6201C15.5132 9.46989 13.7701 7.72681 11.6199 7.72681C9.46968 7.72681 7.72656 9.46989 7.72656 11.6201C7.72656 13.7703 9.46968 15.5135 11.6199 15.5135Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9666 29.2666L44.6666 36.9666L36.9666 44.6666L29.2666 36.9666",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3398 31.04L21.4131 29.1134L29.1131 21.4133L31.0398 23.34",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7732 25.0732C34.8999 27.1999 34.8999 30.6466 32.7732 32.7732C30.6466 34.8999 27.1999 34.8999 25.0732 32.7732",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.44 35.6533L35.6533 38.4467",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4868 50.9134C24.4868 54.4668 21.6068 57.3468 18.0534 57.3468C14.5001 57.3468 11.6201 54.4668 11.6201 50.9134V15.5134",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4134 11.4999L49.8867 13.2266L55.4134 14.9532L57.1401 20.4799L58.8667 14.9532L64.4001 13.2266L58.8667 11.4999L57.1401 5.96655L55.4134 11.4999Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7327 4.0933L39.7061 4.27332L40.7327 4.45329L40.9127 5.48665L41.0927 4.45329L42.1261 4.27332L41.0927 4.0933L40.9127 3.06665L40.7327 4.0933Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9602 58.3868L55.9336 58.5668L56.9602 58.7467L57.1403 59.7801L57.3203 58.7467L58.3469 58.5668L57.3203 58.3868L57.1403 57.3601L56.9602 58.3868Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2731 5.91333L59.7798 38.42L38.4198 59.78L5.91309 27.2734",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyMobile);
export default __webpack_public_path__ + "static/media/company_mobile.efdc4d2ef86d76c5b04209df3547a308.svg";
export { ForwardRef as ReactComponent };